import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { formatDate } from '@angular/common';
import { PatientModel } from 'src/app/models/PatientsModel';
import { PatientsService } from 'src/app/services/PatientsService';
import { DoctorsService } from 'src/app/services/DoctorsService';
import { RoomsModel } from 'src/app/models/RoomsModel';
import { RoomsService } from 'src/app/services/RoomsService';

import { ProtocolHDService } from 'src/app/services/ProtocolHDService';
import { ProtocolHDModel } from 'src/app/models/ProtocolHDModel';
import { CanserModel } from 'src/app/models/CanserModel';
import { CanserService } from 'src/app/services/CanserService';

@Component({
  selector: 'app-report-from-to',
  templateUrl: './report-from-to.component.html',
  styleUrls: ['./report-from-to.component.css'],
})
export class ReportFromToComponent implements OnInit {
  private sub: any;
  fromDate = '';
  toDate = '';
  patientCode ='';
  patientFName ='';
  telMobile ='';

  docCode = '';
  docName = '';
  roomCode = '09';
  roomName = '';
  prHdCode = '';
  prHdName = '';
  cancertype ='';
  morreasons = '';
  roomtype ='';
  compCode = '1';
  fromDateD = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  toDateD = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  screenTitle = '';
  dateVisable= false;
  yearVisable = true;
  patVisable = true;
  docVisable = true;
  roomVisable = true;
  protocolVisable = true;
  canVisable = true;
  morVisable = true;
  roomtypebvisable = true;

  buttVisable = false;

  doctorsList: DoctorsModel[] = [];
  roomsList: RoomsModel[] = [];
  doctors: DoctorsModel[] = [];
  patientList: PatientModel[] = [];
  protocolList : ProtocolHDModel[]= [];
  cancerlist:CanserModel[] = [];

  @Output() submitClicked = new EventEmitter<any>();

  constructor(
    public dialogRef: MatDialogRef<ReportFromToComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    public storage: LocalStorageService,
    public route: Router,
    public doctorSelectedData: DoctorsModel,
    public pateintssService: PatientsService, public patients: PatientModel,
    public patientSelectedData: PatientModel,
    public doctorsService:DoctorsService,
    public roomsService : RoomsService,
    public protocolService: ProtocolHDService,
    public protocol: ProtocolHDModel,
    public canserService : CanserService,

  ) {}

  ngOnInit(): void {

    this.screenTitle = this.data.dialogTitle;
                              // 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N-Proto_Y'
    if (this.data.dialogText == 'Year_y-Date_N-Pat_N-Doc_N-Butt_Y-Room_N-Can_N-Mor_N')
        {
              this.dateVisable = true;
              this.yearVisable = false ;
              this.patVisable = true;
              this.docVisable = true;
              this.roomVisable = true;
              this.buttVisable = false;
              this.protocolVisable = true;
              this.canVisable = true;
              this.canVisable = true;
        }
        if (this.data.dialogText == 'Year_N-Date_Y-Pat_N-Doc_Y-Butt_Y-Room_N')
        {
              this.dateVisable = false;
              this.yearVisable = true ;
              this.patVisable = true;
              this.docVisable = false;
              this.roomVisable = true;
              this.buttVisable = false;
              this.protocolVisable = true;
              this.canVisable = true;
              this.canVisable = true;
        }
                                    // Year_y-Date_N-Pat_N-Doc_N-Butt_YRoom_N
        if (this.data.dialogText == 'Year_N-Date_Y-Pat_Y-Doc_N-Butt_N-Room_N-Can_N-Mor_N')
        {
                this.dateVisable = false;
                this.yearVisable = true;
                this.patVisable = false;
                this.docVisable = true;
                this.roomVisable = true;
                this.buttVisable = true;
                this.protocolVisable = true;
                this.canVisable = true;
                this.canVisable = true;
                this.canVisable = true;
        }
        if (this.data.dialogText == 'Year_N-Date_N-Pat_Y-Doc_N-Butt_N-Room_N-Can_N-Mor_N')
        {
                this.dateVisable = true;
                this.yearVisable = true;
                this.patVisable = false;
                this.docVisable = true;
                this.roomVisable = true;
                this.buttVisable = true;
                this.protocolVisable = true;
                this.canVisable = true;
                this.canVisable = true;
                this.canVisable = true;
        }
        if (this.data.dialogText == 'Year_N-Date_Y-Pat_N-Doc_Y-Butt_Y-Room_N-Can_N-Mor_N')
        {
                this.dateVisable = false;
                this.yearVisable = true;
                this.patVisable = true;
                this.docVisable = false;
                this.roomVisable = true;
                this.buttVisable = false;
                this.protocolVisable = true;
                this.canVisable = true;
                this.canVisable = true;
        }
        if (this.data.dialogText == 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_Y')
        {
                this.dateVisable = false;
                this.yearVisable = true;
                this.patVisable = true;
                this.docVisable = true;
                this.roomVisable = false;
                this.buttVisable = false;
                this.protocolVisable = true;
                this.canVisable = true;
                this.canVisable = true;
        }
        if (this.data.dialogText == 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N-Can_N-Mor_N')
        {
                this.dateVisable = false;
                this.yearVisable = true;
                this.patVisable = true;
                this.docVisable = true;
                this.roomVisable = true;
                this.buttVisable = false;
                this.protocolVisable = true;
                this.canVisable = true;
                this.canVisable = true;

        }
        if (this.data.dialogText == 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N-Can_Y-Mor_N')
        {
                this.dateVisable = false;
                this.yearVisable = true;
                this.patVisable = true;
                this.docVisable = true;
                this.roomVisable = true;
                this.buttVisable = false;
                this.protocolVisable = true;
                this.canVisable = false;
                this.morVisable = true;
        }

        if (this.data.dialogText == 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_Y-RoomType_Y')
        {
                this.dateVisable = false;
                this.yearVisable = true;
                this.patVisable = true;
                this.docVisable = true;
                this.roomVisable = true;
                this.buttVisable = false;
                this.protocolVisable = true;
                this.canVisable = true;
                this.morVisable = true;
                this.roomtypebvisable = false;
        }

        if (this.data.dialogText == 'Year_N-Date_Y-Pat_Y-Doc_N-Butt_N-Room_N')
        {
                this.dateVisable = false;
                this.yearVisable = true;
                this.patVisable = false;
                this.docVisable = true;
                this.roomVisable = true;
                this.buttVisable = false;
                this.protocolVisable = true;
                this.canVisable = true;
                this.morVisable = true;
                this.roomtypebvisable = true;
        }

        if (this.data.dialogText ==  'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N-Proto_Y-Can_N-Mor_N')
        {
                this.dateVisable = false;
                this.yearVisable = true;
                this.patVisable = true;
                this.docVisable = true;
                this.roomVisable = true;
                this.buttVisable = false;
                this.protocolVisable = false;
                this.canVisable = true;
                this.morVisable = true;
              }
        if (this.data.dialogText ==  'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N-Can_Y-Mor_Y')
        {
                this.dateVisable = false;
                this.yearVisable = true;
                this.patVisable = true;
                this.docVisable = true;
                this.roomVisable = true;
                this.buttVisable = false;
                this.protocolVisable = true;
                this.canVisable = false;
                this.morVisable = false;
        }
        this.retrivePatientsTop();
        this.retriveDoctorsLookupTop();
        this.retriveRoomsLookupTop();
        this.retriveProtocolLookupTop();
        this.retrievecancerLookup();
  }
  FunClose() {
    this.dialogRef.close();
  }
  retrivePatients() {
    this.patientList = [];
    this.pateintssService.getPatients(this.patientCode, this.patientFName, this.telMobile, this.compCode).subscribe((data: PatientModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.patientList[i] = data[i];
      }
      console.log(data);
    })
  }
  retrivePatientsTop() {
    this.pateintssService.getPatientsTop(this.compCode).subscribe((data: PatientModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.patientList[i] = data[i];
      }
      console.log(data);
    })
  }
  ReportPrint(doctorSelectedData: DoctorsModel) {
    doctorSelectedData.docName = this.fromDate;
    doctorSelectedData.docAddress = this.data.dialogTitle;
    doctorSelectedData.docPhone = this.prHdCode;
    doctorSelectedData.docMobile = this.morreasons; //// Moratity Reasons
    doctorSelectedData.docmail = this.roomtype; //// Room Type
    doctorSelectedData.docTitle = this.toDate;
    doctorSelectedData.docWMMobile =  formatDate(this.fromDateD, 'yyyy-MM-dd', 'en');
    doctorSelectedData.docWmail =  formatDate(this.toDateD, 'yyyy-MM-dd', 'en');
    doctorSelectedData.docCode= this.docCode;
    doctorSelectedData.docDepartment = this.roomCode;
    doctorSelectedData.docUser = this.cancertype;   //// CancerType
    this.submitClicked.emit(this.doctorSelectedData);

    this.dialogRef.close();
  }

  SelectPatient(patient: PatientModel){
    this.patientSelectedData.patientCode = patient.patientCode
    this.patientSelectedData.patientFName = this.fromDate
    this.patientSelectedData.education= this.toDate
    this.patientSelectedData.telHome = formatDate(this.fromDateD, 'yyyy-MM-dd', 'en')
    this.patientSelectedData.patientFullName = formatDate(this.toDateD, 'yyyy-MM-dd', 'en')
    this.patientSelectedData.addressHome = this.data.dialogTitle;
    this.patientSelectedData.addressBusin = this.prHdCode;
    this.submitClicked.emit(this.patientSelectedData);
    this.dialogRef.close();

  }

  retriveDoctorsLookupTop() {
    this.doctorsService
      .getDoctorsLookupTop(this.compCode)
      .subscribe((data: DoctorsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.doctorsList[i] = data[i];
        }
        console.log(data);
      });
  }

  retriveRoomsLookupTop() {
    this.roomsService
      .getRoomsLookupTop(this.compCode)
      .subscribe((data: RoomsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.roomsList[i] = data[i];
        }
        console.log(data);
      });
  }

  retriveProtocolLookupTop() {
    this.protocolService.getProtocolHDLookupToop(this.compCode).subscribe((data: ProtocolHDModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.protocolList[i] = data[i];
      }
      console.log(data);
    })
  }
  retrievecancerLookup() {
   this.canserService.getCancerLookupTop().subscribe((data:CanserModel[])=>{
  for(let i=0 ; i <data.length; i++)
  {this.cancerlist[i]=data[i];}})
  }
}
